export * from './InfoLabel';
